<template>
<v-card flat >
  <v-toolbar dense flat dark >
    <v-text-field clearable
      prepend-icon="search"
      @keyup.esc="search=''"
      v-model="search"
      label="Search" />
    <v-btn @click="expandAll=!expandAll" icon >
      <v-icon>library_add</v-icon>
    </v-btn>
  </v-toolbar>
  <v-treeview selectable open-on-click multiple-active
    ref="producttree"
    v-model="selected"
    :search="search"
    :filter="filter"
    :items="items" >

    <template v-slot:label="{ item }">
      {{item.name}}
      <v-chip dark v-if="item.archived===true" class="v-chip--x-small" color="warning" >archived</v-chip>
      <v-chip dark v-if="item.active===false" class="v-chip--x-small" color="warning" >deactivated</v-chip>
    </template>

    <template v-slot:append="{ item }">

      <v-chip outline class="v-chip--x-small"
        v-for="location in item.locations"
        :key="`${item.id}-${location.id}`" >
          <v-icon small left >place</v-icon>
          {{location.name}}</v-chip>

      <!-- <v-chip color="info" dark style="min-width:150px;"
        v-if="item.owner_name" class="v-chip--x-small white--text justify-right text-right"  >
        <v-icon small left >person</v-icon> {{item.owner_name}}
      </v-chip> -->

    </template>

  </v-treeview>
</v-card>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductTreePicker',
  props: {
    value: { type: Array, required: false },
    spaceIds: { type: Array, required: false },
    expanded: { type: Boolean, default: false }
  },
  data () {
    return {
      search: null,
      selected: [],
      expandAll: false
    }
  },
  mounted () {
    if (this.expanded) {
      this.expandAll = true
      this.$refs.producttree.updateAll(this.expandAll)
    }
  },
  watch: {
    selected () {
      let products = this.selected.filter((item) => {
        return (String(item).indexOf('-') === -1)
      })
      this.$emit('input', products)
    },
    expandAll () {
      this.$refs.producttree.updateAll(this.expandAll)
    }
  },
  methods: {
    filter (item, search, textKey) {
      let val = item[textKey]
      return (search && val && val.toLowerCase().indexOf(search.toLowerCase()) > -1)
    }
  },
  computed: {
    ...mapGetters(['spaces', 'getProducts', 'getPractitionerById']),
    filteredSpaces () {
      if (this.spaceIds && this.spaceIds.length > 0) {
        return this.spaces.filter((space) => {
          return this.spaceIds.indexOf(space.id) !== -1
        })
      }
      return this.spaces
    },
    items () {
      return this.filteredSpaces.map((item) => {
        let r = Math.random().toString()
        let members = []
        if (item.members) { members = item.members }
        return {
          id: `${item.id}-${r}`,
          name: item.title,
          children: members.map((practitionerId) => {
            let practitioner = this.getPractitionerById(practitionerId)
            return {
              id: `${item.id}-${practitioner.id}`,
              name: practitioner.full_name,
              type: 'practitioner',
              active: practitioner.is_active,
              archived: practitioner.archived,
              children: this.getProducts(practitionerId, item.id).map((item) => {
                return {
                  id: item.id,
                  name: item.title,
                  owner_name: item.owner_name,
                  locations: item.locations
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductTreePicker.vue?485984c0